// src/api/canteenLogApi.js
import apiClient from './axios';

const canteenLogApi = {
  getAll: async (page = 1, pageSize = 20, search = '') => {
    const response = await apiClient.get('/canteen-log/', {
      params: {
        page,
        page_size: pageSize,
        search: search.trim() || undefined,
      },
    });
    return response.data;
  },
};

export default canteenLogApi;